import React from "react";
import { css } from "@emotion/css";

interface CancelledBannerProps {
  title: string;
  message: string;
}

export const CancelledBanner: React.FC<CancelledBannerProps> = ({ title, message }) => (
  <div className={cancelledBannerStyle}>
    <div className={cancelledIconStyle}>❌</div>
    <div className={cancelledContentStyle}>
      <h2 className={cancelledTitleStyle}>{title}</h2>
      <p className={cancelledMessageStyle}>{message}</p>
    </div>
  </div>
);

const cancelledBannerStyle = css`
  background: rgba(244, 67, 54, 0.1);
  border: 1px solid rgba(244, 67, 54, 0.3);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
`;

const cancelledIconStyle = css`
  font-size: 24px;
`;

const cancelledContentStyle = css`
  flex: 1;
`;

const cancelledTitleStyle = css`
  font-size: 18px;
  font-weight: 600;
  color: #f44336;
  margin: 0 0 8px 0;
`;

const cancelledMessageStyle = css`
  font-size: 14px;
  color: #adadad;
  margin: 0;
`; 